<template>
    <v-menu>
        <template v-slot:activator="{props}">
            <v-list-item v-if="!isMobile" v-bind="props" class="menu-button py-0">
                <v-list-item-title>
                    <v-icon size="small" class="me-4">mdi-cog</v-icon>
                    <span class="text-subtitle-2">
                        {{ $t('manage_reservation') }}
                    </span>
                    <v-icon end>mdi-menu-down</v-icon>
                </v-list-item-title>
            </v-list-item>
            <v-btn
                v-else
                icon="mdi-dots-vertical"
                size="small"
                variant="text"
                v-bind="props"
                data-cy="show-manage-reservation-mobile"
            />
        </template>
        <v-list density="compact">
            <v-list-item v-if="authStore.isTO1" data-cy="show-history" @click="historyModal = true">
                <v-list-item-title>{{ $t('history_of_change') }}</v-list-item-title>
            </v-list-item>
            <v-list-item
                v-if="showMoveToArchive"
                data-cy="archive"
                class="list-item cursor-pointer"
                @click="archiveModal = true"
            >
                <v-list-item-title>
                    {{ order.active ? $t('archive_reservation') : $t('restore_reservation') }}
                </v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
    <client-only>
        <v-dialog v-model="historyModal">
            <order-history :order-id="order.orderId" @close-modal="historyModal = false" />
        </v-dialog>
        <ArchiveReservation v-model="archiveModal" />
    </client-only>
</template>
<script setup lang="ts">
    import OrderHistory from '@/components/account/OrderHistory.vue'
    import ArchiveReservation from '~/components/account/orders/ArchiveReservation.vue'

    const props = defineProps<{
        showMoveToArchive: boolean
    }>()

    const historyModal = ref<boolean>(false)
    const archiveModal = ref<boolean>(false)

    const app = useNuxtApp()

    const order = computed(() => {
        return runtimeStore.orderDetails
    })

    const isMobile = computed(() => {
        return app.$breakpoint.smAndDown
    })
</script>
<style scoped>
    .menu-button {
        width: fit-content;
        min-height: 36px;
        border: 1px solid rgba(0, 0, 0, 1);
        border-radius: 4px !important;
        cursor: pointer;
        text-align: center;
    }
    .list-item:hover {
        background-color: rgba(0, 0, 0, 0.04);
    }
    .list-item:active {
        background-color: rgba(0, 0, 0, 0.08);
    }
</style>
